module.exports = __webpack_public_path__ + "img/about-us-section.0e332043.png";